import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableOrderRoutes = Loadable(
  './OrderRoutes',
  () => import(/* webpackChunkName: "Order" */ './OrderRoutes'),
  () => [(require as any).resolveWeak('./OrderRoutes')]
);
